'use strict';
define(['./util'], function (utils) {

    var namespaces = {};

    function DropdownMenu(el, options) {

        // member variables
        this.menubar = el;
        this.menuItemLinks = [];
        this.options = options;
        this.onMenuOpenCallbacks = [];

        // add menu items
        this.addMenuItems(el.querySelectorAll(this.options.menuItem));

        // add click handler for document click
        if (!DropdownMenu.hasDocumentClickHandler) {
            addDocumentClickHandler(this);
            DropdownMenu.hasDocumentClickHandler = true;
        }

        // add current instance to the list for later retrieval
        if (this.options.namespace) {
            namespaces[this.options.namespace] = this;
        }
    }

    /**
     * Returns cached instance of DropdownMenu
     * @param {string} namespace instance regestered with
     */
    DropdownMenu.get = function(namespace) {
        return namespaces[namespace] || null;
    };

    DropdownMenu.prototype = {
        addMenuItems: function(els) {
            for (var i=0, n=els.length; i < n; i++) {
                this.addMenuItem(els[i]);
            }
        },
        addMenuItem: function(menuItem) {
            this.addMenuItemLink(
                menuItem.querySelector(this.options.menuItemLink),
                menuItem.querySelector(this.options.menuDropdown)
            );
        },
        addMenuItemLink: function(menuItemLink, menuDropdown) {
            if (!menuItemLink || !menuDropdown) {
                return false;
            }
            if (this.menuItemLinks.indexOf(menuItemLink) == -1) { //eslint-disable-line
                menuDropdown.setAttribute('aria-hidden', 'true');
                this.menuItemLinks.push(menuItemLink);
                this.addMenuItemLinkEvent(menuItemLink);
                this.stopDropdownClickEvent(menuDropdown);
            }
        },
        toggleDropdownEvent: function(menuItemLink) {
            var link = menuItemLink.previousElementSibling.checked ? null : menuItemLink,
                self = this;

            setTimeout(function() {
                self.toggleDropdown(link);
            }, 0);
        },
        addMenuItemLinkEvent: function(menuItemLink) {
            menuItemLink.toggleDropdownEventFn = this.toggleDropdownEvent.bind(this, menuItemLink);
            menuItemLink.href = 'javascript:;';
            menuItemLink.addEventListener('click', menuItemLink.toggleDropdownEventFn);
        },
        removeMenuItemLinkEvent: function(menuItemLink) {
            if(menuItemLink.toggleDropdownEventFn) {
                menuItemLink.removeEventListener('click', menuItemLink.toggleDropdownEventFn);
            }

            if(menuItemLink.href === 'javascript:;') {
                menuItemLink.href = menuItemLink.oldHref;
            }
        },
        toggleDropdown: function(menuItemLinkClicked) {
            var self = this;
            this.menuItemLinks.map(function(menuItemLink) {
                self.toggleAccessibility(menuItemLink, menuItemLinkClicked);
                if (menuItemLink === menuItemLinkClicked) {
                    menuItemLinkClicked.previousElementSibling.checked = !menuItemLinkClicked.previousElementSibling.checked;
                    self.executeOnMenuOpenCallbacks(menuItemLinkClicked);
                } else {
                    menuItemLink.previousElementSibling.checked = false;
                }
            });
        },
        stopDropdownClickEvent: function(menuDropdown) {
            menuDropdown.addEventListener('click', function(evt) {
                evt.stopPropagation();
            });
        },
        toggleAccessibility: function(menuItemLink, menuItemLinkClicked) {
            var dropdownClicked = (menuItemLink === menuItemLinkClicked);
            var menuItem = dropdownClicked ? menuItemLinkClicked : menuItemLink;
            var dropdown = menuItem.nextElementSibling;
            var tabindexToGet = dropdownClicked ? -1 : 0;
            var tabindexToSet = dropdownClicked ? 0 : -1;
            var ariaHidden = dropdownClicked ? 'false' : 'true';
            var els = dropdown.querySelectorAll('[tabindex="' + tabindexToGet + '"]');

            dropdown.setAttribute('aria-hidden', ariaHidden);
            utils.setTabIndex(els, tabindexToSet);
        },

        /**
         * Add onMenuOpen event callback
         * @param {Function} : Callback function
         * @returns {Boolean} : TRUE if callback added
         */
        onMenuOpen: function(callback) {
            var self = this;

            if (self.onMenuOpenCallbacks.indexOf(callback) > -1) {
                return false;
            }

            self.onMenuOpenCallbacks.push(callback);

            return function() {
                self.onMenuOpenCallbacks = self.onMenuOpenCallbacks.filter(function(item) {
                    return item !== callback;
                });
            };
        },

        /**
         * Executes onMenuOpen callback functions list
         * @param {HTMLElement} - Menuitem clicked
         */
        executeOnMenuOpenCallbacks: function(menuItemLinkClicked) {
            this.onMenuOpenCallbacks.map(function(callback) {
                callback(menuItemLinkClicked);
            });
        }
    };

    // ---- private methods -----

    function addDocumentClickHandler(context) {
        document.body.addEventListener('click', function() {
            DropdownMenu.prototype.toggleDropdown.apply(context);
        });
    }

    return DropdownMenu;
});


// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/DropdownMenu.js